import { watch, type Ref } from "vue";

/**
 * 校正結果が揃ったタイミングで Mark の貼り直しを促す。
 *
 * LexicalEditor は loading 解除と同じ描画フラッシュでマウントされるため、
 * 結果の反映（AI 結果の復元など）がその後の microtask で走ると
 * editor-ready 時点の指摘は 0 件のままになり、下線もジャンプ先の Mark も作られない。
 * 実行済みフラグの立ち上がりを検知して再適用を呼び出す。
 */
export function bindMarkRefreshOnProofreadingExecuted(
  hasExecutedProofreading: Ref<boolean>,
  onRefresh: () => void,
): void {
  watch(hasExecutedProofreading, (executed, previous) => {
    if (executed && previous !== true) {
      onRefresh();
    }
  });
}
